import styled from 'styled-components'
import tw from 'twin.macro'

export interface IAppDropZoneProps {
  hasPadding: boolean
}

export const AppAcceptedFileType = styled.div.attrs({
  className: 'block text-xs text-center leading-4 !pointer-events-none',
})<IAppDropZoneProps>`
  ${(p) => (p.hasPadding ? tw`pt-4` : '')}
`
export const AppFileType = styled.p`
  ${tw`text-xs text-center leading-4 px-6 pt-2 pb-7 xs:block sm:hidden`}
`

export const AppDropFileWrapper = styled.div`
  ${tw`w-full flex flex-col items-center justify-center text-center p-8 min-h-[120px] cursor-pointer transition`}
  border: 2px dashed #A5A5A5;
  border-radius: 0.5rem;
  &:hover {
    border-color: #705af8;
  }
`

export const AppUploadFileWrapper = styled.div`
  input[type='file'] {
    display: none;
  }
  .questionLabel {
    padding: 10px;
    background: white;
    color: #5e06b9;
  }
`
